export var getTransportOptionLabel = function getTransportOptionLabel(distance, label) {
  return "\n  ".concat(distance, "\n  ").concat(label, "\n");
};